import legal from "./legal-et";

const et = {
  nav: { about: "Ettevõte", services: "Teenused", approach: "Lähenemine", sectors: "Valdkonnad", contact: "Kontakt", cta: "Võta ühendust", menu: "Menüü", close: "Sulge", lang: "Keel" },
  hero: {
    eyebrow: "GridJob OÜ — Tallinn, Eesti",
    lines: ["Sündmused.", "Oskused.", "Äri.", "Üks võrk."],
    sub: "Eesti ettevõte, mis toodab sündmusi, arendab erialast koolitust ja loob ärisidemeid, mis hoiavad valdkonnad liikumises — üle piiride.",
    cta: "Alusta vestlust",
    cta2: "Mida me teeme",
    caption: "Sündmuste produktsioon · Kutseõpe · Äriteenused",
    meta: ["Asut. 2026", "Tallinn, EE", "EN · ET · IT"],
    scroll: "Keri",
  },
  marquee: ["Sündmuste produktsioon", "Erialane koolitus", "Õpiteed", "Äriarendus", "Äriteenused", "Partnerlused", "Huvirühmade kaasamine", "Tarnijate koordineerimine", "Digitaalne kommunikatsioon"],
  about: {
    label: "01 — Ettevõte",
    title: "Oleme ühenduslüli ettevõtete, spetsialistide, koolitajate, erialaliitude ja sündmuste korraldajate vahel.",
    body: [
      "GridJob OÜ on 2026. aastal Tallinnas registreeritud osaühing. Tegeleme sündmuste produktsiooni ja koordineerimise, erialase koolituse, äriarenduse ning ettevõtetele suunatud teenustega.",
      "Meie töö hõlmab rahvusvaheliste projektide arendamist, partnerluste loomist, huvirühmade kaasamist, tarnijate ja spetsialistide koordineerimist, digitaalset kommunikatsiooni ning praktiliste koolitus- ja töövahendite toomist tööturule. Toetame piiriüleseid algatusi ja aitame organisatsioonidel plaanid tulemusteks muuta.",
    ],
    facts: [
      { k: "Õiguslik vorm", v: "Osaühing (OÜ)" },
      { k: "Registrijärgne asukoht", v: "Tallinn, Eesti" },
      { k: "Asutatud", v: "2026" },
      { k: "Töökeeled", v: "Inglise · eesti · itaalia" },
    ],
    imgAlt: "Tallinna vanalinna siluett päikeseloojangul merelt vaadatuna",
  },
  services: {
    label: "02 — Teenused",
    title: "Neli valdkonda. Üks koordineeritud meeskond.",
    intro: "Ühendame produktsioonikogemuse, koolituste kavandamise ja äritoe, et projektid, inimesed ja tarnijad toimiksid ühtse süsteemina.",
    items: [
      { title: "Sündmuste produktsioon ja koordineerimine", desc: "Ideest etenduspäevani: planeerime, toodame ja koordineerime sündmusi, toimumiskohti, tehnilisi tarnijaid ja kohapealseid meeskondi.", points: ["Produktsiooni planeerimine ja eelarvestamine", "Toimumiskohtade, meeskondade ja tehniliste tarnijate koordineerimine", "Demonstratsioonid, töötoad ja esitlused"], img: "/img/crowd.jpg", alt: "Kontserdipublik lavavalguses" },
      { title: "Erialane koolitus ja õpiteed", desc: "Kavandame ja korraldame praktilisi, õpiväljunditele suunatud koolitusi, mis viivad õppijad päris töökeskkonda.", points: ["Kursuste ja õpiväljundite kavandamine", "Koolitajate koordineerimine ja õppijate tugi", "Õppematerjalide lokaliseerimine ja kvaliteedikontroll"] },
      { title: "Äriarendus", desc: "Aitame organisatsioonidel laiendada haaret, leida õigeid partnereid ja siseneda uutele turgudele Eestis ja välismaal.", points: ["Partnerluste loomine ja huvirühmade kaardistamine", "Rahvusvaheliste projektide arendamine", "Turule sisenemise tugi Balti regioonis"] },
      { title: "Äriteenused", desc: "Operatiivne tugi, mis hoiab projektid käigus: koordineerimine, kommunikatsioon ja usaldusväärne elluviimine.", points: ["Tarnijate ja spetsialistide koordineerimine", "Digitaalne kommunikatsioon ja levitamine", "Andmete kogumine, aruandlus ja hindamine"], img: "/img/team.jpg", alt: "Meeskond nõupidamislaua ümber" },
    ],
  },
  approach: {
    label: "03 — Lähenemine",
    title: "Kuidas me töötame",
    steps: [
      { title: "Kuula ja kaardista", desc: "Alustame tegelikest vajadustest: kaardistame huvirühmad, oskuste lüngad ja piirangud enne mis tahes ettepanekut." },
      { title: "Ühenda", desc: "Toome samasse lauda õiged ettevõtted, spetsialistid, toimumiskohad ja koolitajad." },
      { title: "Koordineeri", desc: "Haldame logistikat, tarnijaid, ajakavasid ja kommunikatsiooni, et partnerid saaksid keskenduda sisule." },
      { title: "Mõõda ja jätka", desc: "Kogume andmeid, hindame tulemusi ja kavandame kasutuselevõttu, et töö elaks projektist kauem." },
    ],
  },
  network: {
    label: "04 — Võrgustik",
    title: "Keda me ühendame",
    intro: "GridJob asub toimiva võrgustiku keskmes. Iga ühendus põhineb tööturu konkreetsel vajadusel.",
    items: [
      { title: "Ettevõtted", desc: "Tööandjad, stuudiod, toimumiskohad ja teenusettevõtted, kes otsivad oskustöötajaid ja usaldusväärseid partnereid." },
      { title: "Spetsialistid", desc: "Vabakutselised, tehnikud ja eksperdid, kes soovivad areneda, ümber õppida või leida uusi kliente." },
      { title: "Koolitajad", desc: "Koolid, akadeemiad ja koolituskeskused, kes vajavad päris töökeskkonda ja valdkonna sisendit." },
      { title: "Erialaliidud", desc: "Kutse- ja valdkonnaliidud, mis esindavad ja toetavad oma liikmeid." },
      { title: "Korraldajad", desc: "Festivalid, promootorid ja produtsendid, kes vajavad koordineeritud meeskondi ja tarnijaid." },
    ],
  },
  sectors: {
    label: "05 — Valdkonnad",
    title: "Kus me tegutseme",
    items: [
      { title: "Muusika ja live-heli", desc: "Kontserdiproduktsioon, live-heliteenused ja nende taga olevad spetsialistid.", img: "/img/mixer.jpg", alt: "Live-helipuldi valgustatud liugurid" },
      { title: "Audiovisuaal ja ringhääling", desc: "Video-, ringhäälingu- ja audiovisuaalse tootmise ettevõtted ning võttegrupid.", img: "/img/broadcast.jpg", alt: "Kaameraoperaatori siluett värviliste stuudiotulede taustal" },
      { title: "Sündmused ja festivalid", desc: "Konverentsid, festivalid, esitlused ja igas mõõdus kultuurisündmused.", img: "/img/crowd.jpg", alt: "Festivalipublik valgustatud lava ees" },
      { title: "Haridus ja koolitus", desc: "Kutse- ja täiskasvanuhariduse pakkujad, koolitajad ja juhendajad.", img: "/img/workshop.jpg", alt: "Täiskasvanud koostööd tegemas koolitustöötoas" },
      { title: "Ettevõtted ja tööandjad", desc: "Väikesed ja keskmise suurusega ettevõtted, kes loovad meeskondi ja partnerlusi.", img: "/img/team.jpg", alt: "Ärimeeskonna koosolek laua ümber" },
    ],
  },
  principles: {
    label: "06 — Põhimõtted",
    title: "Kuidas me vastutame",
    items: [
      { title: "Lõimitud andmekaitse", desc: "Töötleme isikuandmeid seaduslikult ja minimaalselt, kooskõlas isikuandmete kaitse üldmääruse ja isikuandmete kaitse seadusega." },
      { title: "Võrdsed võimalused", desc: "Kujundame tegevused ligipääsetavaks ja kaasavaks, olenemata soost, taustast, vanusest või puudest." },
      { title: "Ausus ja läbipaistvus", desc: "Selged kokkulepped, huvide konflikti puudumine ja aus aruandlus igale partnerile ja kliendile." },
      { title: "Kvaliteet ja elluviimine", desc: "Määratud vastutus, mõõdetavad tulemused ja dokumenteeritud kvaliteedikontroll igas etapis." },
    ],
  },
  contact: {
    label: "07 — Kontakt",
    title: "Loome koos midagi, mis töötab.",
    intro: "Räägi meile oma sündmusest, koolitusideest või partnerlusest. Vastame igale päringule, tavaliselt mõne tööpäeva jooksul.",
    fields: { name: "Täisnimi", email: "E-post", org: "Organisatsioon (valikuline)", topic: "Teema", message: "Sõnum" },
    topics: { events: "Sündmuste produktsioon", training: "Erialane koolitus", business: "Äriarendus", services: "Äriteenused", partnership: "Partnerlus", other: "Muu" },
    consent: "Olen tutvunud",
    consentLink: "privaatsuspoliitikaga",
    consentEnd: "ja nõustun, et GridJob OÜ töötleb minu andmeid sellele päringule vastamiseks.",
    submit: "Saada sõnum",
    sending: "Saadan…",
    success: "Aitäh — sinu sõnum on kätte saadud.",
    error: "Sõnumit ei õnnestunud saata. Palun proovi uuesti.",
    required: "Palun täida kõik kohustuslikud väljad ja nõustu privaatsuspoliitikaga.",
    details: { address: "Registrijärgne aadress", email: "E-post", phone: "Telefon", registry: "Registrikood" },
  },
  footer: {
    tagline: "Sündmused, oskused ja äri — ühendatud.",
    company: "Ettevõtte andmed",
    legal: "Õiguslik teave",
    rights: "Kõik õigused kaitstud.",
    admin: "Töötajate sisselogimine",
    photos: "Fotod: Unsplash (Unsplash License).",
  },
  cookie: { text: "See veebileht kasutab ainult hädavajalikku salvestust (keele-eelistus ja töötajate turvaline sisselogimine). Jälgimis- ega reklaamiküpsiseid ei kasutata.", link: "Küpsiste poliitika", ok: "Selge" },
  legalNav: { imprint: "Õiguslik teave", privacy: "Privaatsuspoliitika", cookies: "Küpsiste poliitika", accessibility: "Ligipääsetavus", terms: "Kasutustingimused", back: "Tagasi avalehele", updated: "Viimati uuendatud" },
  legal,
};

export default et;
